import React, { useEffect, useState } from "react";
import {
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  modalCloseIcon,
} from "../../../../../images";
import config from "../../../../../config/config";
import Modal from "react-bootstrap/Modal";
import "./galleryPopupDemo.scss";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";
import useTheme from "../../../../../components/useTheme/useTheme";

const galleryTitles = [
  { key: "project_renders_media", title: "Project Photos & Renders" },
  { key: "completed_products_media", title: "Products | Materials" },
  { key: "sites_inprogress_media", title: "Sites In Progress" },
  { key: "others_media", title: "Other Media" },
];

const GalleryPopupDemo = (props) => {
  const { theme } = useTheme();

  const [columns, setColumns] = useState(4);
  const { categoryData } = props;
  const imageUrl = config.aws_object_url + "business/";

  // "all" mode: categoryData.key === "all" and categoryData.data is the full profileData
  const isAllMode = categoryData?.key === "all";
  const [activeBtn, setActiveBtn] = useState("project_renders_media");

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 768) setColumns(3);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(1);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Reset active tab when popup opens
  useEffect(() => {
    if (isAllMode) {
      setActiveBtn("project_renders_media");
    }
  }, [isAllMode, categoryData]);

  // Get images based on mode
  const getImagesForGrid = () => {
    if (isAllMode) {
      return categoryData?.data?.[activeBtn] || [];
    }
    return categoryData?.data || [];
  };

  const createMasonryLayout = () => {
    let arranged = Array.from({ length: columns }, () => []);
    const images = getImagesForGrid();

    images?.forEach((img, i) => {
      if (img.visibility) {
        arranged[i % columns].push({
          src: `${imageUrl}${img.url}`,
          width: img.width,
          height: img.height,
          blurHash: img.blurHash,
          visibility: img.visibility,
          _id: img._id,
        });
      }
    });

    return arranged;
  };

  const arrangedImages = createMasonryLayout();

  return (
    <>
      <Modal
        {...props}
        centered
        className={`Gallery_popup_modal ${
          theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button className="custom-cancel-btn" onClick={props.handleClose}>
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        {/* <Modal.Body>
              <h2 className="Gallery_popup_heading">{categoryData?.title || ""}</h2>
              <div className="masonry-gallery">
                {arrangedImages.map((column, colIndex) => (
                  <div className="masonry-column" key={colIndex}>
                    {column.map((src, index) => (
                      <div className="masonry-item" key={index}>
                        <img src={src} alt={`Gallery ${index}`} loading="lazy" />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </Modal.Body> */}

        {/* <Modal.Body>
          <h2 className="Gallery_popup_heading">Project Photos & Renders</h2>
          <div className="masonry-gallery-demo">
      {arrangedImages.map((column, colIndex) => (
        <div className="masonry-column-demo" key={colIndex}>
          {column.map((src, index) => (
            <div className="masonry-item-demo" key={index}>
              <img src={src} alt={`Gallery ${index}`} />
            </div>
          ))}
        </div>
      ))}
    </div>

          <h2 className="Gallery_popup_heading">Project Photos & Renders</h2>
          <div className="masonry-gallery-two">
            {arrangedImages.map((src, index) => (
              <div className="masonry-item" key={index}>
                <img src={src} alt={`Gallery ${index}`} />
              </div>
            ))}
          </div>
        </Modal.Body> */}
        <Modal.Body>
          <h2 className="Gallery_popup_heading">{categoryData?.title || ""}</h2>

          {/* Category filter tabs (only in "all" mode from View More) */}
          {isAllMode && (
            <div className="gallery_filter_tabs">
              {galleryTitles.map((cat) => (
                <div
                  key={cat.key}
                  className={`filter_tab ${activeBtn === cat.key ? "active" : ""}`}
                  onClick={() => setActiveBtn(cat.key)}
                >
                  {cat.title}
                </div>
              ))}
            </div>
          )}

          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => (
                  <div className="masonry-item" key={item._id || index}>
                    <BlurGalleryImage
                      item={item}
                      activeGallerImages={false}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GalleryPopupDemo;
